module.exports = __webpack_public_path__ + "img/dd8.ff265536.jpg";